import React from 'react';
import type NavigationNodeData from './NavigationNodeData';
import styles from './ProgressNavigationBar.module.css';

type Props = {
  number: string,
  item: NavigationNodeData,
  selected: boolean,
};

function NavigationNode({ number, item, selected }: Props) {
  return (
    <div className={`${styles.node} ${selected ? styles.selected : ''}`}>
      {selected ? (
        <a href={item.url} className={styles.circle}>
          {number}
        </a>
      ) : (
        <div className={styles.circle}>{number}</div>
      )}
      <div className={styles.title}>{item.title}</div>
    </div>
  );
}

export default NavigationNode;
